import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_AWARDS_MUTATION } from '../graphql/mutations'
import { transformToSaveAwardsArgs } from '../graphql/transformers'
import { SAVE_AWARDS } from '../redux/action-types'

const useSaveAwardsMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.awards.awards)

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_AWARDS_MUTATION,
        { data: transformToSaveAwardsArgs(data) },
        dispatch,
        SAVE_AWARDS,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveAwardsMutation
